import React, { useEffect, useRef } from 'react'

/**
 * This component applies styles to the parent div of the content it wraps.
 *
 * @param {object} props - Component properties
 * @param {object} props.style - Styles that will be added on the father component
 * @param {React.ReactNode} props.children - The content that the component returns.
 *
 */

const ParentStyler = ({ style = {}, children }) => {
  const containerRef = useRef(null)

  useEffect(() => {
    const parentDiv = containerRef.current
      ? containerRef.current.parentNode
      : null
    if (parentDiv) {
      Object.assign(parentDiv.style, style)
    }
  }, [style])

  return <div ref={containerRef}>{children}</div>
}

export default ParentStyler
